import { axiosInstance } from "../services/axiosInstance";
import catchAsync from "../utils/catchAsync";

export const getTimeOffs = catchAsync(async (teamMemberId) => {
  const { data } = await axiosInstance.get(`salon/${teamMemberId}/time-offs`);
  return data;
});

export const getTimeOffTypes = catchAsync(async () => {
  const { data } = await axiosInstance.get("salon/time-off-types");
  return data;
});

export const addTimeOff = catchAsync(async (teamMemberId, body) => {
  return await axiosInstance.post(`salon/${teamMemberId}/time-offs`, body);
});

export const deleteTimeOff = catchAsync(async (teamMemberId, timeOff) => {
  const { data } = await axiosInstance.delete(
    `salon/${teamMemberId}/time-offs/${timeOff}`
  );
  return data;
});
